// Haalt één publiek intakeformulier op bij de Cloud Function.
//
// De pagina draait zonder login en mag daarom niet zelf in Firestore lezen: een
// geweigerde read levert geen fout op maar een lege lijst, waarna instellingen
// als captcha en het privacy-vinkje terugvallen op "uit". Deze functie is de
// enige leesweg en geeft een echte fout terug, zodat de pagina dicht kan vallen.
// AI-CONTEXT: See docs/patterns.md#cf-public-onrequest-read
// AI-CONTEXT: See docs/decisions.md#adr-022

const PUBLIC_INTAKE_ENDPOINT =
    process.env.NODE_ENV === 'production'
        ? '/api/intakeform'
        : 'https://europe-west1-deccos-app.cloudfunctions.net/getPublicIntakeForm';

/**
 * @param {'invalid-argument'|'not-found'|'unavailable'} code
 * @param {string} message
 * @returns {Error & {code: string}}
 */
const intakeError = (code, message) => {
    const error = /** @type {Error & {code: string}} */ (new Error(message));
    error.code = code;
    return error;
};

/**
 * @param {{client: string, formId: string}} params
 * @returns {Promise<object>} de publieke payload van het formulier
 */
const fetchPublicIntakeForm = async ({ client, formId }) => {
    if (!client || !formId) {
        throw intakeError('invalid-argument', 'Onvolledige link naar het formulier.');
    }

    let response;
    try {
        response = await fetch(PUBLIC_INTAKE_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ client, formId }),
        });
    } catch (err) {
        // Netwerkfout: bewust niet stil doorlopen — de pagina moet dit tonen.
        throw intakeError('unavailable', 'Het formulier kon niet worden geladen.');
    }

    if (response.status === 404) {
        throw intakeError('not-found', 'Dit formulier bestaat niet (meer).');
    }

    if (!response.ok) {
        throw intakeError('unavailable', 'Het formulier kon niet worden geladen.');
    }

    return response.json();
};

export default fetchPublicIntakeForm;
export { PUBLIC_INTAKE_ENDPOINT };
